var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"VideoBg"},[_c('video',{ref:"video",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},_vm._l((_vm.sources),function(source){return _c('source',{attrs:{"src":source,"type":_vm.getMediaType(source)}})})),_vm._v(" "),_c('div',{staticClass:"VideoBg__content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b01d54f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-videobg/src/VideoBackground.vue
// module id = null
// module chunks = 